module.exports = __webpack_public_path__ + "static/img/customer_default.bcd0ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer_default.png
// module id = ZY+3
// module chunks = 1